import { DefaultBadge } from '@frontend/components/badge';
import { EquipmentState, EquipmentStateName } from '@frontend/equipment/types';
import { LuDoorOpen } from 'react-icons/lu';

interface SlotCardProps {
    onClick: () => void;
    isSelected: boolean;
    slotName: string;
    quantity: number;
    equipment?: {
        name: React.ReactNode;
        state: EquipmentStateName | null;
    };
    equipmentStates?: {
        state: EquipmentStateName | null;
        quantity: number;
    }[];
}

const getEquipmentState = (state: EquipmentStateName | null): EquipmentState =>
    state ? (EquipmentState.getByValue(state) ?? EquipmentState.UNKNOWN) : EquipmentState.UNKNOWN;

export const SlotCard = ({ onClick, isSelected, slotName, quantity, equipment, equipmentStates }: SlotCardProps) => {
    return (
        <div
            onClick={onClick}
            className={`${isSelected ? 'bg-brand-secondary text-background-surface' : 'bg-background-surface text-foreground-default'} border-border-default inline-flex w-full items-center justify-start gap-2 self-stretch rounded-xl border px-3 py-2`}>
            <div className='flex min-h-6 w-full flex-col items-center justify-between gap-2'>
                <div className='flex w-full justify-between'>
                    <div className='flex items-center justify-center gap-2'>
                        <LuDoorOpen className='h-5 w-5' />
                        <div className='justify-start text-base font-semibold'>{slotName}</div>
                    </div>
                    {quantity > 1 && <div className='h-5 justify-start text-base font-medium'>{quantity}x</div>}
                </div>
                {equipment && (
                    <div className='flex w-full flex-col items-start justify-start'>
                        <div className='justify-start text-sm font-medium'>{equipment.name}</div>
                        {equipment && equipment.state && !equipmentStates?.length && (
                            <DefaultBadge
                                label={EquipmentState.getByValue(equipment.state)?.displayName}
                                styles={{
                                    container: {
                                        color: EquipmentState.getType(equipment.state)
                                    },
                                    label: 'text-xs text-background-surface'
                                }}
                            />
                        )}
                    </div>
                )}
                {equipmentStates && equipmentStates.length > 0 && (
                    <div className='flex w-full flex-wrap items-start justify-start gap-1'>
                        {equipmentStates.map((equipmentState) => {
                            const state = getEquipmentState(equipmentState.state);

                            return (
                                <DefaultBadge
                                    key={equipmentState.state ?? 'unknown'}
                                    label={
                                        <>
                                            {equipmentState.quantity > 1 && `${equipmentState.quantity}x `}
                                            {state.displayName}
                                        </>
                                    }
                                    styles={{
                                        container: {
                                            color: equipmentState.state ? EquipmentState.getType(equipmentState.state) : 'bg-brand-muted'
                                        },
                                        label: 'text-xs text-background-surface'
                                    }}
                                />
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
};
